import React from 'react';
import './Header.css';
import Notifications from '../Notifications';

function Header({ username, currentView }) {
  const getViewTitle = () => {
    const viewTitles = {
      'overview': 'Dashboard',
      'list': 'Test Cases',
      'suites': 'Test Suites',
      'runs': 'Test Runs',
      'tasks': 'Scheduling',
      'reports': 'Reports & Analytics',
      'defects': 'Defects',
      'recording': 'Test Recorder',
      'settings': 'Settings',
      'admin': 'Admin',
    };
    return viewTitles[currentView] || 'Dashboard';
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">{getViewTitle()}</h1>
          <span className="system-status-badge">
            <span className="status-dot"></span>
            System Healthy
          </span>
        </div>
        <div className="header-right">
          <Notifications />
        </div>
      </div>
    </header>
  );
}

export default Header;

